import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const BUTTON_DEFAULTS = {
    text: "Get started",
    href: "#",
    variant: "primary",
    target: "_self",
    align: "left",
};
const VARIANT_STYLES = {
    primary: "background:#111;color:#fff;border:1px solid #111",
    secondary: "background:transparent;color:#111;border:1px solid rgba(17,17,17,0.2)",
    ghost: "background:transparent;color:#111;border:1px solid transparent",
};
export const buttonWidget = {
    type: "button",
    defaultProps: BUTTON_DEFAULTS,
    renderHtml(props) {
        const variant = props.variant ?? "primary";
        const alignWrapper = props.align ? ` style="text-align:${props.align}"` : "";
        const styles = [
            "display:inline-block",
            "padding:10px 18px",
            "border-radius:8px",
            "font-weight:500",
            "text-decoration:none",
            "line-height:1.2",
            "transition:opacity 0.2s",
            VARIANT_STYLES[variant],
            props.fullWidth ? "width:100%;text-align:center" : "",
        ]
            .filter(Boolean)
            .join(";");
        const rel = props.target === "_blank" ? ' rel="noopener noreferrer"' : "";
        const target = props.target ? ` target="${props.target}"` : "";
        const btn = `<a class="emk-button" href="${escapeAttr(props.href)}"${target}${rel} style="${styles}">${escapeHtml(props.text)}</a>`;
        return `<div class="emk-button-wrap"${alignWrapper}>${btn}</div>`;
    },
};
//# sourceMappingURL=button.js.map